export default "__VITE_ASSET__BG$1JEQV__"